import { Component, Vue } from 'vue-property-decorator';
import { request } from '@/tools/request.ts';

@Component<ConfirmationPage>({
  components: {
    //
  },
})
export default class ConfirmationPage extends Vue {
  protected enrolled: boolean = true;
  protected currentStudent: any = {};

  public mounted() {
    document.body.classList.add('landingPage');
    this.setStudent();
  }

  public destroyed() {
    document.body.classList.remove('landingPage');
  }

  protected setStudent() {
    this.currentStudent.id = this.$route.query.id;
    this.currentStudent.name = this.$route.query.name;
    this.enrollStudent();
  }

  protected enrollStudent() {
    const payload: any = {
      id: this.currentStudent.id,
      statusUpdate: 'enrolled',
    };

    request('post', `https://us-central1-lexlibris-api.cloudfunctions.net/webApi/updateStudent`, payload).then(
      (response: any) => {
        //
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected unSubscribeStudent() {
    const payload: any = {
      id: this.currentStudent.id,
      statusUpdate: 'not enrolled',
      studentName: this.currentStudent.name,
    };

    this.enrolled = false;
    this.updateStudent(payload);
  }

  protected updateStudent(payload: StudentPayload) {
    request('post', 'https://us-central1-lexlibris-api.cloudfunctions.net/webApi/updateStatus', payload).then(
      (response: any) => {
        //
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

}

type StudentPayload = {
  id: string;
  statusUpdate: string;
}
